import React from 'react';

// types
import { PPF_USER_TYPE_OPTIONS } from 'types/user';
import { FormikContext } from 'formik';
import Lookup from 'components/controls/Lookup';

interface UserTypeLookupProps {
  name: string;
  value?: number[] | null;
  onChange?: (value: number[] | null) => void;
  label?: string;
  placeholder?: string;
  disabled?: boolean;
  required?: boolean;
  error?: boolean;
  helperText?: string;
  size?: 'small' | 'medium';
  fullWidth?: boolean;
  loading?: boolean;
  onClear?: () => void;
  showClearButton?: boolean;
  multiple?: boolean;
}

const UserTypeLookup = ({
  name,
  value,
  onChange,
  label = 'User Types',
  placeholder = 'Select user type',
  disabled = false,
  required = false,
  error = false,
  helperText,
  size = 'medium',
  fullWidth = true,
  multiple = true,
  loading = false,
  onClear,
  showClearButton = true
}: UserTypeLookupProps) => {
  // const formik = useFormikContext<any>();
  const formik = React.useContext(FormikContext);

  const selectedOptions = PPF_USER_TYPE_OPTIONS.filter((c) => value?.includes(c.value));

  const handleClear = (e: React.MouseEvent) => {
    e.stopPropagation();

    const emptyValue: number[] | null = [];

    if (formik) {
      formik.setFieldValue(name, emptyValue, true);
      formik.setFieldTouched(name, true, true);
    }

    onChange?.(emptyValue);
    onClear?.();
  };

  const handleChange = (newValue: any) => {
    const ids = newValue ? newValue.map((r: { value: number }) => r.value) : [];

    if (formik) {
      formik.setFieldValue(name, ids, true);
      if (formik.touched[name]) {
        formik.setFieldTouched(name, true, true);
      }
    }

    onChange?.(ids);
  };

  return (
    <Lookup
      lookupID="user-type"
      label={label}
      placeholder={placeholder}
      size={size}
      fullWidth={fullWidth}
      showAddButton={false}
      loading={loading}
      disabled={disabled}
      required={required}
      error={error}
      helperText={helperText}
      value={undefined}
      selectedOptions={selectedOptions}
      dataSource={PPF_USER_TYPE_OPTIONS}
      getOptionLabel={(o) => o.userType}
      isOptionEqualToValue={(option, value) => option.value === value.value}
      onChange={handleChange}
      onBlur={() => formik?.setFieldTouched(name, true, true)}
      handleClear={handleClear}
      multiple={multiple}
    />
  );
};

export default UserTypeLookup;